import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import Spinner from "../Helpers/Spinner";

// const ProtectedRoute = ({ allowedRoles }) => {
//   const { user, isAuthenticated, isLoading } = useAuth();
//   const location = useLocation();

//   if (isLoading) {
//     return <Spinner />;
//   }

//   if (!isAuthenticated || !user) {
//     return <Navigate to="/login" state={{ from: location }} replace />;
//   }

//   // if (!isAuthenticated) {
//   //   return <Navigate to="/login" state={{ from: location }} replace />;
//   // }

//   if (allowedRoles && !allowedRoles.includes(user.role)) {
//     return <Navigate to="/unauthorized" state={{ from: location }} replace />;
//   }

//   return <Outlet />;
// };

// export default ProtectedRoute;

const ProtectedRoute = ({ allowedRoles }) => {
  const { user, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  console.log("ProtectedRoute Check:", {
    isLoading,
    isAuthenticated,
    user,
    path: location.pathname,
  });

  if (isLoading) {
    console.log("ProtectedRoute: Showing spinner due to isLoading=true");
    return <Spinner />;
  }

  if (!isAuthenticated || !user) {
    console.log("ProtectedRoute: Redirecting to /login", {
      isAuthenticated,
      user,
    });
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    console.log("ProtectedRoute: Redirecting to /unauthorized", {
      role: user.role,
      allowedRoles,
    });
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  console.log("ProtectedRoute: Rendering Outlet for user", user.email);
  return <Outlet />;
};

export default ProtectedRoute;
